/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type IconEnum = (typeof IconEnum)[keyof typeof IconEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IconEnum = {
  Archive: 'Archive',
  Unarchive: 'Unarchive',
  Boarding: 'Boarding',
  CareInfo: 'CareInfo',
  Calendar: 'Calendar',
  Call: 'Call',
  Cancel: 'Cancel',
  CreditCard: 'CreditCard',
  AlertCaution: 'AlertCaution',
  Day: 'Day',
  Daycare: 'Daycare',
  DropIn: 'DropIn',
  Edit: 'Edit',
  AlertError: 'AlertError',
  Evening: 'Evening',
  ExternalLink: 'ExternalLink',
  ExternalLinkBlue: 'ExternalLinkBlue',
  Grooming: 'Grooming',
  AlertInfo: 'AlertInfo',
  Map: 'Map',
  Megaphone: 'Megaphone',
  Morning: 'Morning',
  Notes: 'Notes',
  NowBolt: 'NowBolt',
  Pets: 'Pets',
  Person: 'Person',
  Photo: 'Photo',
  Plus: 'Plus',
  TrustLogo: 'TrustLogo',
  Report: 'Report',
  Requests: 'Requests',
  Stopwatch: 'Stopwatch',
  Time: 'Time',
  Send: 'Send',
  AlertSuccess: 'AlertSuccess',
  DogTraining: 'DogTraining',
  Sitting: 'Sitting',
  Video: 'Video',
  Walking: 'Walking',
  ReferFinancial: 'ReferFinancial',
} as const;
